// i18n is imported first for side-effect ordering: it must be registered
// before any page module evaluates, or the candidate's first paint falls back
// to English.
import './i18n';
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';

import { createCandidateRouter } from './candidate-app/createCandidateRouter';
import { useDocumentLocale } from './candidate-app/documentLocale';
import { buildAppTheme } from './appTheme';

const router = createCandidateRouter();

const theme = buildAppTheme({ readOnlyControls: 'segmented' });

const InterviewApp = () => {
  useDocumentLocale('documentTitle.app');
  return (
    <MantineProvider theme={theme}>
      <ModalsProvider>
        <Notifications position='top-right' />
        <RouterProvider router={router} />
      </ModalsProvider>
    </MantineProvider>
  );
};

export default InterviewApp;
